<canvas #canvas class="signature-pad-canvas"></canvas>